import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from "react-router-dom";
import { Form, OverlayTrigger, Button, Tooltip } from "react-bootstrap";
import ViewMembersPanelProject from '../../../../components/view-members-projects/view-members-projects.jsx';
import ViewMembersPanelMultiOwner from '../../../../components/view-members-projects/view-members-multi-owner-panel.jsx';
import TaskCreationPopup from "../../../tasks/scenes/task-creation-popup/task-creation-popup";
import PlusIcon from "../../../../components/plus-icon/Plus-Icon";
import TagViewPanelNew from "../../../../components/tag-view-panel/tag-view-panel-new.jsx";
import TaskCreateDocumentModal from '../../../tasks/scenes/task-create-document-modal';
import { selectUser, selectUserID } from '../../../../redux/user/user-selector';
import ProjectActionsDropdown from '../../../../components/project-actions-dropdown/ProjectActionsDropdown';
import NewProjectStatusChangePopupNew from '../new-project-status-change-popup/new-project-status-change-popup.jsx';
import { addSelectedProject, deleteSelectedProject } from '../../../../redux/projects/project-actions';
import { selectSelectedProjects } from '../../../../redux/projects/project-selector';
import Status from '../../../../components/status-indicator/Status';
import Priority from '../../../../components/priority/priority';
import "./projects-row.styles.scss";
import PriorityFluentNew from '../../../../components/priority/priority-fluent-new.jsx';
import { FluentTooltip } from '../../../../components/FluentUI/Fluent-Tooltip.jsx';

const ProjectsRowNew = ({
  project,
  projectsUsers,
  projectsGroups,
  onEdit,
  handlePermissions,
  tab,
  refreshTable,
  taskCreateDisabled,
  memberAddDisabled,
  isMultiOwner,
  labels
}) => {
  const [showTaskCreationPopup, setShowTaskCreationPopup] = useState(false);
  const [showProjectStatusChangePopup, setShowProjectStatusChangePopup] = useState(false);
  const [actionObj, setActionObj] = useState({});
  const [dropdown, setDropdown] = useState(false);
  const [showDCTaskModal, setShowDCTaskModal] = useState(false);

  const user = useSelector(selectUser);
  const { department, privileges } = user;
  const userID = useSelector(selectUserID);
  const selectedProjects = useSelector(selectSelectedProjects);
  const dispatch = useDispatch();
  let history = useHistory();

  let projectStatus;
  if (project.StatusId === 1) {
    projectStatus = 'Active';
  } else if (project.StatusId === 2) {
    projectStatus = 'Completed';
  } else {
    projectStatus = 'Archived';
  }

  const onSelect = (e) => {
    if (e.target.checked) {
      dispatch(addSelectedProject(project.Id));
    } else {
      dispatch(deleteSelectedProject(project.Id));
    }
  }

  const onSelectComplete = (e) => {
    setActionObj({
      actiontype: "Complete",
      status: 2
    });
    setShowProjectStatusChangePopup(true);
  }

  const onSelectArchive = (e) => {
    setActionObj({
      actiontype: "Archive",
      status: 0
    });
    setShowProjectStatusChangePopup(true);
  }

  const onSelectReopen = (e, actionText = "") => {
    let popupLabelText = (e.target.innerText == "Reopen" ? "Reopen" : "Unarchive");

    if (actionText != "") popupLabelText = actionText;

    setActionObj({
      actiontype: "Active",
      status: 1,
      popupLabel: popupLabelText,
    });
    setShowProjectStatusChangePopup(true);
  }

  const handleToggle = (payload) => setDropdown(payload);

  const onShowDCTask = () => setShowDCTaskModal(true);

  const onHideDCTask = () => setShowDCTaskModal(false);

  return (
    <tr className="project-row1">
      <td></td>
      <td className="project-checkbox1">
        <Form.Check onClick={e => {onSelect(e)}} aria-label="selectTask" type='checkbox' checked={selectedProjects.includes(project.Id)}/>
      </td>
      <td className="project-name-row">
        <OverlayTrigger
          placement="bottom-start"
          overlay={<Tooltip>
            {project.Name}
          </Tooltip>}>
          <div className="m-0">{project.Name}</div>
        </OverlayTrigger>
      </td>
      <FluentTooltip
        target={
          <td className=" project-priority-row">
            <PriorityFluentNew priority={project.Priority} />
          </td>
        }
        text={project.Priority}
      />    
      <td className="project-status-row">
        <Status status={projectStatus} />
      </td>
      <td className="project-taskCount-row">
          <div className="project-task-count-container">
            <div className="project-task-count">
              <OverlayTrigger
                placement="bottom-start"
                overlay={
                  <Tooltip>
                    {projectStatus} : {project.TasksActiveCount}<br></br>
                    Completed : {project.TasksCompletedCount}
                  </Tooltip>
                }>
                <div className="m-0">{project.TasksTotalCount}</div>
              </OverlayTrigger>
            </div>
            { taskCreateDisabled ?
              <React.Fragment>
                <OverlayTrigger
                  placement="bottom-end"
                  overlay={
                    <Tooltip>
                      You don't have access to create {labels?.TaskPlural ?? "tasks"}. Please contact administration for assistance.
                    </Tooltip>
                  }
                >
                  <div className="project-task-plus-icon">
                    <PlusIcon
                      func={() => setShowTaskCreationPopup(true) }
                      disabled = {taskCreateDisabled}
                    />
                  </div>
                </OverlayTrigger>
              </React.Fragment>
              :
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip>
                    Add a {labels?.TaskSingular ?? "task"}
                  </Tooltip>}>
                <div className="project-task-plus-icon">
                  <PlusIcon
                    func={() => setShowTaskCreationPopup(true) }
                  />
                </div>
              </OverlayTrigger>
            }
          </div>
      </td>
      <td className="project-tags-row">
        <TagViewPanelNew tags={project.Tags} />
      </td>
      <td className="project-members-row">
        {isMultiOwner ?
          <ViewMembersPanelMultiOwner
          UserID={project.OwnerId}
          members={[...new Set([...(project.Members || []), ...(project.Groups || [])])]}
          onEdit={onEdit}
          projects={project}
          projectsUsers={projectsUsers}
          projectsGroups={projectsGroups}
          memberAddDisabled={memberAddDisabled}
        /> :
        <ViewMembersPanelProject
          UserID={project.OwnerId}
          members={[...new Set([...(project.Members || []), ...(project.Groups || [])])]}
          onEdit={onEdit}
          projects={project}
          projectsUsers={projectsUsers}
          projectsGroups={projectsGroups}
          memberAddDisabled={memberAddDisabled}
        />
        }
      </td>
      <td className="project-date-row">
        {new Date(project.Start).toLocaleDateString(department.dateFormatID)}
      </td>
      <td className="project-date-row">
        {new Date(project.End).toLocaleDateString(department.dateFormatID)}
      </td>
      <td className="action-buttions-row">
        <ProjectActionsDropdown
          project={project}
          status={project.StatusId}
          tab={tab}
          onSelectComplete={onSelectComplete}
          onSelectArchive={onSelectArchive}
          onSelectReopen={onSelectReopen}
          onSelectEdit={() => history.push(`/projects/edit/${project.Id}`)}
          projectEdit = {memberAddDisabled}
          show={dropdown}
          handleToggle={handleToggle}
          labels={labels}
        />
      </td>
      <NewProjectStatusChangePopupNew
        new={true}
        show={showProjectStatusChangePopup}
        onHide={() => setShowProjectStatusChangePopup(false)}
        type={actionObj.actiontype}
        status={actionObj.status}
        button="Confirm"
        onEdit={onEdit}
        projects={[project]}
        refreshTable={refreshTable}
        popupLabel={actionObj.actiontype == "Active" ? actionObj.popupLabel : ""}
        labels={labels}
      />
      { showTaskCreationPopup &&
        <TaskCreationPopup
          userID={userID}
          previousTab={"projects"}
          projectID={project.Id}
          show={showTaskCreationPopup}
          onShowDCTask = { () => onShowDCTask() }
          onHide={() => setShowTaskCreationPopup(false)}
          privileges={privileges}
          handlePermissions={handlePermissions}
        />
      }
      { showDCTaskModal &&
        <TaskCreateDocumentModal
          show = { showDCTaskModal }
          onHide = {() => onHideDCTask()}
          projectId = { project.Id }
          dateFormatID = { department.dateFormatID } // The value of department needs to be deprecated later
          privileges = { privileges } // The value of department needs to be deprecated later
        />
      }
    </tr>
  );
};

ProjectsRowNew.propTypes = {
  project: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired,
  groups: PropTypes.array.isRequired,
  projectsUsers: PropTypes.array,
  projectsGroups: PropTypes.array,
  onEdit: PropTypes.func,
  handlePermissions: PropTypes.func,
  tab: PropTypes.string.isRequired,
  refreshTable: PropTypes.func,
  taskCreateDisabled: PropTypes.bool.isRequired,
  memberAddDisabled: PropTypes.bool.isRequired,
  isMultiOwner: PropTypes.bool,
  labels: PropTypes.shape({
          ProjectSingular: PropTypes.string,
          ProjectPlural: PropTypes.string,
          ProjectSingularPossessive: PropTypes.string,
          ProjectPluralPossessive: PropTypes.string,
          TaskSingular: PropTypes.string,
          TaskPlural: PropTypes.string,
          TaskSingularPossessive: PropTypes.string,
          TaskPluralPossessive: PropTypes.string,
          FormSingular: PropTypes.string,
          FormPlural: PropTypes.string,
          FormSingularPossessive: PropTypes.string,
          FormPluralPossessive: PropTypes.string,
  }),
};

ProjectsRowNew.defaultProps = {
  isMultiOwner: false,
}

export default ProjectsRowNew;
